module.exports = __webpack_public_path__ + "static/media/bf-safe.c20ba2de.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/bf-safe.png
// module id = 1221
// module chunks = 0